// extracted by css-extract-rspack-plugin
export default {"visuallyHidden":"visuallyHidden-j7TdB"};